import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';

export function NotFoundRoute() {
  return (
    <>
      <PageHeader title="Not found" description="That route doesn't exist." />
      <Link to="/" className="text-sm text-primary hover:underline">← Back to overview</Link>
    </>
  );
}
